// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reconciliation-dashboard {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
  background: linear-gradient(135deg, #f8fafc 0%, #fef7ed 50%, #f0f9ff 100%);
  min-height: 100vh;
  padding: 24px;
}

/* Card Components */
.recon-card {
  background: white;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: all 0.3s ease;
}

.recon-card:hover {
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  transform: translateY(-2px);
}

.recon-card-header {
  padding: 20px 24px;
  border-bottom: 1px solid #f1f5f9;
  background: linear-gradient(to right, #f8fafc, #ffffff);
}

.recon-card-title {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  display: flex;
  align-items: center;
}

.recon-card-content {
  padding: 24px;
}

/* Header Styles */
.recon-header {
  background: white;
  border-radius: 20px;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
  padding: 28px;
  margin-bottom: 28px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
}

.recon-gradient-title {
  background: linear-gradient(135deg, #dc2626 0%, #ea580c 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-size: 38px;
  font-weight: 800;
  margin-bottom: 8px;
}

/* KPI Cards Grid */
.recon-kpi-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 28px;
}

.recon-kpi-card {
  background: white;
  border-radius: 16px;
  padding: 24px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.recon-kpi-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #dc2626, #ea580c);
}

.recon-kpi-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
}

.recon-kpi-value {
  font-size: 28px;
  font-weight: 800;
  margin-bottom: 8px;
}

.recon-kpi-label {
  font-size: 14px;
  color: #64748b;
  line-height: 1.4;
}

/* Emirates Grid */
.emirates-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin: 24px 0;
}

.emirate-card {
  background: white;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  padding: 0;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
}

.emirate-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  border-color: #3b82f6;
}

.emirate-card-header {
  padding: 20px;
  border-bottom: 1px solid #f1f5f9;
  background: linear-gradient(to right, #f8fafc, #ffffff);
}

.emirate-card-content {
  padding: 20px;
}

/* Status Indicators */
.status-matched {
  color: #059669;
}
.status-partial {
  color: #d97706;
}
.status-short {
  color: #dc2626;
}
.status-excess {
  color: #2563eb;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  margin-left: 8px;
}

.status-badge.matched {
  background: #dcfce7;
  color: #166534;
}
.status-badge.partial {
  background: #fef3c7;
  color: #92400e;
}
.status-badge.short {
  background: #fee2e2;
  color: #991b1b;
}
.status-badge.excess {
  background: #dbeafe;
  color: #1e40af;
}

/* AI Anomalies */
.ai-anomalies {
  background: linear-gradient(135deg, #fef3c7, #fef7ed);
  border: 1px solid #fbbf24;
  border-radius: 16px;
  padding: 24px;
  margin-top: 24px;
}

.ai-anomaly-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.ai-anomaly-item {
  background: white;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
  border: 1px solid #fde68a;
  border-left: 4px solid #f59e0b;
  transition: all 0.2s ease;
}

.ai-anomaly-item:hover {
  transform: translateX(4px);
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.15);
}

/* Filter Bar */
.recon-filter-bar {
  display: flex;
  gap: 16px;
  margin: 20px 0;
  flex-wrap: wrap;
}

.recon-filter-item {
  background: white;
  border: 1px solid #e2e8f0;
  padding: 12px 16px;
  border-radius: 12px;
  font-size: 14px;
  color: #475569;
  display: flex;
  align-items: center;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
}

.recon-filter-item:hover {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

/* Button Styles */
.recon-btn {
  display: inline-flex;
  align-items: center;
  padding: 12px 24px;
  border-radius: 12px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  font-size: 14px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.recon-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.recon-btn-success {
  background: linear-gradient(135deg, #059669, #10b981);
  color: white;
}

.recon-btn-success:hover {
  background: linear-gradient(135deg, #047857, #059669);
}

.recon-btn-primary {
  background: linear-gradient(135deg, #2563eb, #3b82f6);
  color: white;
}

.recon-btn-primary:hover {
  background: linear-gradient(135deg, #1d4ed8, #2563eb);
}

.recon-btn-secondary {
  background: white;
  color: #2563eb;
  border: 1px solid #e2e8f0;
}

.recon-btn-secondary:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
}

/* Drilldown Views */
.drilldown-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  padding: 20px;
  background: white;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
}

/* Data Grids */
.data-grid {
  display: grid;
  gap: 16px;
}

.data-grid-cols-3 {
  grid-template-columns: repeat(3, 1fr);
}

.data-grid-cols-2 {
  grid-template-columns: repeat(2, 1fr);
}

/* Chart Containers */
.chart-container {
  background: white;
  border-radius: 16px;
  padding: 24px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  margin-bottom: 24px;
}

/* Service Cards */
.service-card {
  background: white;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  padding: 20px;
  transition: all 0.2s ease;
}

.service-card:hover {
  border-color: #3b82f6;
  box-shadow: 0 8px 15px -3px rgba(0, 0, 0, 0.1);
}

/* Navigation */
.nav-arrow {
  transition: transform 0.2s ease;
}

.emirate-card:hover .nav-arrow {
  transform: translateX(3px);
}

/* Value Formatting */
.positive-value {
  color: #059669;
}
.negative-value {
  color: #dc2626;
}
.neutral-value {
  color: #6b7280;
}

/* Icon Styles */
.recon-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  background: linear-gradient(135deg, #dc2626, #ea580c);
  color: white;
  box-shadow: 0 4px 6px -1px rgba(220, 38, 38, 0.3);
}

/* Text Utilities */
.text-sm {
  font-size: 14px;
}
.text-lg {
  font-size: 18px;
}
.text-xl {
  font-size: 20px;
}
.text-2xl {
  font-size: 24px;
}
.text-3xl {
  font-size: 30px;
}

.font-semibold {
  font-weight: 600;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}

.text-slate-600 {
  color: #475569;
}
.text-slate-700 {
  color: #334155;
}
.text-slate-800 {
  color: #1e293b;
}
.text-blue-600 {
  color: #2563eb;
}
.text-green-600 {
  color: #059669;
}
.text-red-600 {
  color: #dc2626;
}
.text-amber-600 {
  color: #d97706;
}
.text-emerald-600 {
  color: #059669;
}

/* Spacing Utilities */
.mb-2 {
  margin-bottom: 8px;
}
.mb-3 {
  margin-bottom: 12px;
}
.mb-4 {
  margin-bottom: 16px;
}
.mb-6 {
  margin-bottom: 24px;
}
.mt-2 {
  margin-top: 8px;
}
.mt-3 {
  margin-top: 12px;
}
.mt-4 {
  margin-top: 16px;
}
.mt-6 {
  margin-top: 24px;
}
.mr-1 {
  margin-right: 4px;
}
.mr-2 {
  margin-right: 8px;
}
.mr-3 {
  margin-right: 12px;
}

.space-y-3 > * + * {
  margin-top: 12px;
}
.space-y-4 > * + * {
  margin-top: 16px;
}
.space-y-6 > * + * {
  margin-top: 24px;
}

/* Flex Utilities */
.flex {
  display: flex;
}
.items-center {
  align-items: center;
}
.justify-between {
  justify-content: space-between;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .recon-kpi-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .emirates-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .data-grid-cols-3 {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .reconciliation-dashboard {
    padding: 16px;
  }

  .recon-kpi-grid {
    grid-template-columns: 1fr;
  }

  .emirates-grid {
    grid-template-columns: 1fr;
  }

  .data-grid-cols-3,
  .data-grid-cols-2 {
    grid-template-columns: 1fr;
  }

  .recon-header {
    padding: 20px;
  }

  .recon-gradient-title {
    font-size: 28px;
  }

  .drilldown-header {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/reconciliation-styles.css"],"names":[],"mappings":"AAAA;EACE,mEAAmE;EACnE,0EAA0E;EAC1E,iBAAiB;EACjB,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;EAC7C,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE;wCACsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,uDAAuD;AACzD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,+CAA+C;EAC/C,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,8CAA8C;EAC9C,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oDAAoD;AACtD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,UAAU;EACV,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,uDAAuD;AACzD;;AAEA;EACE,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,qDAAqD;EACrD,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,+CAA+C;AACjD;;AAEA,eAAe;AACf;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,eAAe;AACf;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qDAAqD;EACrD,YAAY;EACZ,iDAAiD;AACnD;;AAEA,mBAAmB;AACnB;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,8BAA8B;AAChC;;AAEA,sBAAsB;AACtB;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;AACF","sourcesContent":[".reconciliation-dashboard {\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, sans-serif;\n  background: linear-gradient(135deg, #f8fafc 0%, #fef7ed 50%, #f0f9ff 100%);\n  min-height: 100vh;\n  padding: 24px;\n}\n\n/* Card Components */\n.recon-card {\n  background: white;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.recon-card:hover {\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),\n    0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  transform: translateY(-2px);\n}\n\n.recon-card-header {\n  padding: 20px 24px;\n  border-bottom: 1px solid #f1f5f9;\n  background: linear-gradient(to right, #f8fafc, #ffffff);\n}\n\n.recon-card-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1e293b;\n  display: flex;\n  align-items: center;\n}\n\n.recon-card-content {\n  padding: 24px;\n}\n\n/* Header Styles */\n.recon-header {\n  background: white;\n  border-radius: 20px;\n  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e2e8f0;\n  padding: 28px;\n  margin-bottom: 28px;\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n}\n\n.recon-gradient-title {\n  background: linear-gradient(135deg, #dc2626 0%, #ea580c 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  font-size: 38px;\n  font-weight: 800;\n  margin-bottom: 8px;\n}\n\n/* KPI Cards Grid */\n.recon-kpi-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 20px;\n  margin-bottom: 28px;\n}\n\n.recon-kpi-card {\n  background: white;\n  border-radius: 16px;\n  padding: 24px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.recon-kpi-card::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #dc2626, #ea580c);\n}\n\n.recon-kpi-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);\n}\n\n.recon-kpi-value {\n  font-size: 28px;\n  font-weight: 800;\n  margin-bottom: 8px;\n}\n\n.recon-kpi-label {\n  font-size: 14px;\n  color: #64748b;\n  line-height: 1.4;\n}\n\n/* Emirates Grid */\n.emirates-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n  margin: 24px 0;\n}\n\n.emirate-card {\n  background: white;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n  padding: 0;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  overflow: hidden;\n}\n\n.emirate-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);\n  border-color: #3b82f6;\n}\n\n.emirate-card-header {\n  padding: 20px;\n  border-bottom: 1px solid #f1f5f9;\n  background: linear-gradient(to right, #f8fafc, #ffffff);\n}\n\n.emirate-card-content {\n  padding: 20px;\n}\n\n/* Status Indicators */\n.status-matched {\n  color: #059669;\n}\n.status-partial {\n  color: #d97706;\n}\n.status-short {\n  color: #dc2626;\n}\n.status-excess {\n  color: #2563eb;\n}\n\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  margin-left: 8px;\n}\n\n.status-badge.matched {\n  background: #dcfce7;\n  color: #166534;\n}\n.status-badge.partial {\n  background: #fef3c7;\n  color: #92400e;\n}\n.status-badge.short {\n  background: #fee2e2;\n  color: #991b1b;\n}\n.status-badge.excess {\n  background: #dbeafe;\n  color: #1e40af;\n}\n\n/* AI Anomalies */\n.ai-anomalies {\n  background: linear-gradient(135deg, #fef3c7, #fef7ed);\n  border: 1px solid #fbbf24;\n  border-radius: 16px;\n  padding: 24px;\n  margin-top: 24px;\n}\n\n.ai-anomaly-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.ai-anomaly-item {\n  background: white;\n  border-radius: 12px;\n  padding: 16px;\n  margin-bottom: 12px;\n  border: 1px solid #fde68a;\n  border-left: 4px solid #f59e0b;\n  transition: all 0.2s ease;\n}\n\n.ai-anomaly-item:hover {\n  transform: translateX(4px);\n  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.15);\n}\n\n/* Filter Bar */\n.recon-filter-bar {\n  display: flex;\n  gap: 16px;\n  margin: 20px 0;\n  flex-wrap: wrap;\n}\n\n.recon-filter-item {\n  background: white;\n  border: 1px solid #e2e8f0;\n  padding: 12px 16px;\n  border-radius: 12px;\n  font-size: 14px;\n  color: #475569;\n  display: flex;\n  align-items: center;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  transition: all 0.2s ease;\n}\n\n.recon-filter-item:hover {\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n\n/* Button Styles */\n.recon-btn {\n  display: inline-flex;\n  align-items: center;\n  padding: 12px 24px;\n  border-radius: 12px;\n  font-weight: 600;\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-decoration: none;\n  font-size: 14px;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n\n.recon-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n}\n\n.recon-btn-success {\n  background: linear-gradient(135deg, #059669, #10b981);\n  color: white;\n}\n\n.recon-btn-success:hover {\n  background: linear-gradient(135deg, #047857, #059669);\n}\n\n.recon-btn-primary {\n  background: linear-gradient(135deg, #2563eb, #3b82f6);\n  color: white;\n}\n\n.recon-btn-primary:hover {\n  background: linear-gradient(135deg, #1d4ed8, #2563eb);\n}\n\n.recon-btn-secondary {\n  background: white;\n  color: #2563eb;\n  border: 1px solid #e2e8f0;\n}\n\n.recon-btn-secondary:hover {\n  background: #f8fafc;\n  border-color: #cbd5e1;\n}\n\n/* Drilldown Views */\n.drilldown-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 24px;\n  padding: 20px;\n  background: white;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n}\n\n/* Data Grids */\n.data-grid {\n  display: grid;\n  gap: 16px;\n}\n\n.data-grid-cols-3 {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.data-grid-cols-2 {\n  grid-template-columns: repeat(2, 1fr);\n}\n\n/* Chart Containers */\n.chart-container {\n  background: white;\n  border-radius: 16px;\n  padding: 24px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\n  margin-bottom: 24px;\n}\n\n/* Service Cards */\n.service-card {\n  background: white;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  padding: 20px;\n  transition: all 0.2s ease;\n}\n\n.service-card:hover {\n  border-color: #3b82f6;\n  box-shadow: 0 8px 15px -3px rgba(0, 0, 0, 0.1);\n}\n\n/* Navigation */\n.nav-arrow {\n  transition: transform 0.2s ease;\n}\n\n.emirate-card:hover .nav-arrow {\n  transform: translateX(3px);\n}\n\n/* Value Formatting */\n.positive-value {\n  color: #059669;\n}\n.negative-value {\n  color: #dc2626;\n}\n.neutral-value {\n  color: #6b7280;\n}\n\n/* Icon Styles */\n.recon-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 12px;\n  background: linear-gradient(135deg, #dc2626, #ea580c);\n  color: white;\n  box-shadow: 0 4px 6px -1px rgba(220, 38, 38, 0.3);\n}\n\n/* Text Utilities */\n.text-sm {\n  font-size: 14px;\n}\n.text-lg {\n  font-size: 18px;\n}\n.text-xl {\n  font-size: 20px;\n}\n.text-2xl {\n  font-size: 24px;\n}\n.text-3xl {\n  font-size: 30px;\n}\n\n.font-semibold {\n  font-weight: 600;\n}\n.font-bold {\n  font-weight: 700;\n}\n.font-extrabold {\n  font-weight: 800;\n}\n\n.text-slate-600 {\n  color: #475569;\n}\n.text-slate-700 {\n  color: #334155;\n}\n.text-slate-800 {\n  color: #1e293b;\n}\n.text-blue-600 {\n  color: #2563eb;\n}\n.text-green-600 {\n  color: #059669;\n}\n.text-red-600 {\n  color: #dc2626;\n}\n.text-amber-600 {\n  color: #d97706;\n}\n.text-emerald-600 {\n  color: #059669;\n}\n\n/* Spacing Utilities */\n.mb-2 {\n  margin-bottom: 8px;\n}\n.mb-3 {\n  margin-bottom: 12px;\n}\n.mb-4 {\n  margin-bottom: 16px;\n}\n.mb-6 {\n  margin-bottom: 24px;\n}\n.mt-2 {\n  margin-top: 8px;\n}\n.mt-3 {\n  margin-top: 12px;\n}\n.mt-4 {\n  margin-top: 16px;\n}\n.mt-6 {\n  margin-top: 24px;\n}\n.mr-1 {\n  margin-right: 4px;\n}\n.mr-2 {\n  margin-right: 8px;\n}\n.mr-3 {\n  margin-right: 12px;\n}\n\n.space-y-3 > * + * {\n  margin-top: 12px;\n}\n.space-y-4 > * + * {\n  margin-top: 16px;\n}\n.space-y-6 > * + * {\n  margin-top: 24px;\n}\n\n/* Flex Utilities */\n.flex {\n  display: flex;\n}\n.items-center {\n  align-items: center;\n}\n.justify-between {\n  justify-content: space-between;\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .recon-kpi-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .emirates-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .data-grid-cols-3 {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .reconciliation-dashboard {\n    padding: 16px;\n  }\n\n  .recon-kpi-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .emirates-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .data-grid-cols-3,\n  .data-grid-cols-2 {\n    grid-template-columns: 1fr;\n  }\n\n  .recon-header {\n    padding: 20px;\n  }\n\n  .recon-gradient-title {\n    font-size: 28px;\n  }\n\n  .drilldown-header {\n    flex-direction: column;\n    gap: 16px;\n    align-items: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
